import React, {useCallback, useRef, useState} from 'react'

import EntitySelectorSearch from "../../search/search"
import EntitySelectorTabs from "../../content/tabs"
import EntitySelectorListTab from "../list-tab"
import {EntitySelectorEntityType, EntitySelectorListType} from "../../@const"
import {entitySelectorLoadRecentMeetingItems, entitySelectorLoadUpcomingMeetingItems} from "./load-meetings"
import {MenuItemConfig} from "../../../../../layout/top/header/h-menu/h-menu-item-2"
import {SortDirection} from "../../../../data-structures/sort"
import {useEntitySelectorContext} from "../../context"

const MEETING_TABS: MenuItemConfig[] = [
    {id: EntitySelectorListType.RECENT,     label: 'Recent'},
    {id: EntitySelectorListType.UPCOMING,   label: 'Upcoming'},
]

const debug = false
// const debug = "EntitySelectorMeetings"

// Meetings split by time rather than by structure -- what has happened and what
// is coming -- so both sub-tabs are the same flat list, and the sub-tab picks
// which side of "now" `meetingsUds` is asked for.
export default function EntitySelectorMeetings () {
    const context                   = useEntitySelectorContext()

    const [search, setSearch]       = useState('')
    const [listType, setListType]   = useState(EntitySelectorListType.RECENT)

    const listRef                   = useRef<any>()
    const searchRef                 = useRef<any>()

    const onSearchChanged = useCallback((search:string)=>{
        setSearch(search)
    }, [])

    const onCreateNew = useCallback(()=>{
        context.onCreateNew?.(EntitySelectorEntityType.MEETING)
        return
    }, [context])

    const onTypeChanged = useCallback((type:EntitySelectorListType)=>{
        setListType(type)
        searchRef.current?.reset()
    }, [])

    const onKeyDown = useCallback((event: any)=>{
        listRef.current?.onKeyDown(event)
    }, [])

    const isUpcoming = listType === EntitySelectorListType.UPCOMING

    debug && console.log(debug, 'render', listType, search)

    return (
        <>
            <EntitySelectorSearch
                ref                 = {searchRef}
                onKeyDown           = {onKeyDown}
                onSearchChanged     = {onSearchChanged}
            />

            {!search &&
                <EntitySelectorTabs
                    tabs        = {MEETING_TABS}
                    currentId   = {listType}
                    onSelect    = {onTypeChanged}
                    onCreateNew = {context.onCreateNew ? onCreateNew : undefined}
                    createLabel = "New meeting"
                />
            }

            {/* keyed so a sub-tab switch remounts the list instead of showing
                the other tab's rows until its own load comes back */}
            <EntitySelectorListTab
                key                 = {listType}
                ref                 = {listRef}
                search              = {search}
                titleLabel          = "Title"
                dateLabel           = "Date"
                noItemsMessage      = "No meetings found"
                dateSortDirection   = {isUpcoming ? SortDirection.ASC : SortDirection.DESC}
                loadItems           = {isUpcoming ? entitySelectorLoadUpcomingMeetingItems : entitySelectorLoadRecentMeetingItems}
            />
        </>
    )
}
